const PACKAGE_SELECTION_STORAGE_KEY = "synergycoin:selectedPackage";
export const PACKAGE_SELECTION_EVENT = "synergy:package-updated";

const parseNumeric = (value) => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string") {
    const cleaned = value.replace(/[^0-9.]/g, "");
    if (!cleaned) return null;
    const parsed = Number(cleaned);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

const normalizePackage = (input) => {
  if (!input || typeof input !== "object") {
    return null;
  }

  const sources = [input.numericPrice, input.price, input.finalAmount, input.amount];

  let numericPrice = null;
  for (const candidate of sources) {
    const parsed = parseNumeric(candidate);
    if (parsed !== null) {
      numericPrice = parsed;
      break;
    }
  }

  return {
    ...input,
    numericPrice,
  };
};

const dispatchUpdate = (detail) => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(PACKAGE_SELECTION_EVENT, { detail }),
  );
};

export const saveSelectedPackage = (packageData) => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const normalized = normalizePackage(packageData);
    window.localStorage.setItem(
      PACKAGE_SELECTION_STORAGE_KEY,
      JSON.stringify(normalized),
    );
    dispatchUpdate(normalized);
    return normalized;
  } catch (error) {
    console.error("Failed to persist selected package", error);
    return null;
  }
};

export const clearSelectedPackage = () => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.removeItem(PACKAGE_SELECTION_STORAGE_KEY);
    dispatchUpdate(null);
  } catch (error) {
    console.error("Failed to clear selected package", error);
  }
};

export const getSelectedPackage = () => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const stored = window.localStorage.getItem(PACKAGE_SELECTION_STORAGE_KEY);
    if (!stored) {
      return null;
    }

    const parsed = JSON.parse(stored);
    return normalizePackage(parsed);
  } catch (error) {
    console.error("Failed to read stored package", error);
    return null;
  }
};

export const packageHasReferralRestrictions = (packageData) => {
  const normalized = normalizePackage(packageData);
  if (!normalized) {
    return false;
  }

  if (
    normalized.restrictions &&
    (normalized.restrictions.hideReferrals ||
      normalized.restrictions.hideCommunity ||
      normalized.restrictions.hideReferralFeatures)
  ) {
    return true;
  }

  if (typeof normalized.numericPrice !== "number") {
    return false;
  }

  return Math.abs(normalized.numericPrice - 25) < 0.01;
};

export { PACKAGE_SELECTION_STORAGE_KEY };
